import { BUTTON_DISABLED_TEXT, CALYPSO_LIGHT, CALYPSO_MEDIUM, KOALA } from 'HubStyleTokens/colors';
import UIClickable from 'UIComponents/button/UIClickable';
import Small from 'UIComponents/elements/Small';
import { H7 } from 'UIComponents/elements/headings';
import UIMediaObject from 'UIComponents/layout/UIMediaObject';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { AddIcon } from 'foundations-assets';
import styled from 'styled-components';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useIsUngated } from 'automation-ui-core/hooks/authHooks';
import { QUICK_ADD_ACTION } from 'automation-ui-action-features/constants/Gates';
import { useTrackEvent } from 'automation-ui-usage-tracking/usageTrackingHooks';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import { useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledCategoryItem = styled(UIClickable).withConfig({
  displayName: "CategoryItem__StyledCategoryItem",
  componentId: "sc-1qh0y0t-0"
})(["border:1px solid ", ";border-radius:3px;overflow:hidden;margin-top:16px;& + &{margin-top:8px;}"], CALYPSO_MEDIUM);
const StyledItem = styled.div.withConfig({
  displayName: "CategoryItem__StyledItem",
  componentId: "sc-1qh0y0t-1"
})(["height:63px !important;border-left:4px solid ", ";:hover{background:", ";}border-radius:", ";background:", ";color:", ";"], ({
  themeColor
}) => themeColor, props => !props.disabled && CALYPSO_LIGHT, props => props.hasIcon && '3px', props => props.disabled && KOALA, props => props.disabled && BUTTON_DISABLED_TEXT);
const CategoryItem = ({
  label,
  description,
  onClick,
  onQuickAdd,
  quickAddState,
  icon,
  disabled,
  themeColor = 'transparent',
  additionalContent,
  ['data-test-id']: dataTestId
}) => {
  const hasIcon = !!icon;
  const isUngatedForQuickAddAction = useIsUngated(QUICK_ADD_ACTION);
  const trackEvent = useTrackEvent();
  const [quickAddLoading, setQuickAddLoading] = useState(false);
  const [quickAddFailure, setQuickAddFailure] = useState(false);
  const handleQuickAdd = event => {
    if (!onQuickAdd) return;
    trackEvent(Trackables.INTERACTED_WITH_QUICK_ADD_ACTION, {
      actionType: label
    });
    event.stopPropagation();
    setQuickAddLoading(true);
    const result = onQuickAdd(event);
    if (result && typeof result.then === 'function') {
      result.then(() => {
        setQuickAddLoading(false);
      }).catch(() => {
        setQuickAddFailure(true);
        setQuickAddLoading(false);
      });
    } else {
      setQuickAddLoading(false);
    }
  };
  return /*#__PURE__*/_jsx(StyledCategoryItem, {
    onClick: onClick,
    className: hasIcon ? 'm-bottom-2' : '',
    disabled: disabled,
    children: /*#__PURE__*/_jsx(StyledItem, {
      className: "display-flex align-center p-all-3",
      "data-test-id": dataTestId,
      hasIcon: hasIcon,
      disabled: disabled,
      themeColor: themeColor,
      children: /*#__PURE__*/_jsx(UIMediaObject, {
        align: "center",
        itemRight: additionalContent || isUngatedForQuickAddAction && quickAddState !== 'hidden' && /*#__PURE__*/_jsx(Tooltip, {
          title: quickAddState === 'disabled' ? /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation-ui-action-features.action-panel.action-item.quick-add-disabled-tooltip"
          }) : /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation-ui-action-features.action-panel.action-item.quick-add-tooltip"
          }),
          children: /*#__PURE__*/_jsx(LoadingButton, {
            use: "tertiary-light",
            size: "small",
            onClick: handleQuickAdd,
            disabled: disabled || quickAddState === 'disabled',
            loading: quickAddLoading,
            failed: quickAddFailure,
            children: /*#__PURE__*/_jsx(AddIcon, {})
          })
        }),
        itemLeft: hasIcon && icon,
        children: /*#__PURE__*/_jsxs("div", {
          className: "flex-column align-center",
          children: [/*#__PURE__*/_jsx(H7, {
            role: "presentation",
            className: "m-bottom-0",
            children: /*#__PURE__*/_jsx(UITruncateString, {
              children: label
            })
          }), description && /*#__PURE__*/_jsx(Small, {
            children: /*#__PURE__*/_jsx(UITruncateString, {
              className: "m-top-1",
              children: description
            })
          })]
        })
      })
    })
  });
};
export default CategoryItem;